import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/blue-arrow-left.svg'
import _imports_1 from '@/assets/printing-assets/issue-3.svg'


_pushScopeId("data-v-6ec71c9a")
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Return to Troubleshooting", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { id: "info" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { id: "title" }, "My template does not match", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " If your artwork is the correct size and shape but does not match the layout of labels on your sheet you may need to change your template. ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " In some cases we offer the same size label in different layouts to better align with our customers needs. ", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Please confirm that the item number you ordered matches this ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" template. You can find the item number for your product on the packaging for your order, listed on your packing slip, and if you are a registered user in the ")
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" section of the customer account. ")
const _hoisted_14 = {
  key: 0,
  id: "img-wrap"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 0,
  id: "img-wrap"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.bounceTransition, "modal-body"])
      }, [
        _createElementVNode("div", {
          class: "close-svg",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _createVNode(_component_CloseSVG, {
            propId: 'print-close',
            fillColor: '#f7f9fc'
          })
        ]),
        _createElementVNode("h1", _hoisted_1, [
          _createElementVNode("div", {
            id: "return",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.returnToTroubleShooting && _ctx.returnToTroubleShooting(...args)))
          }, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("p", null, [
              _hoisted_10,
              _createElementVNode("strong", null, _toDisplayString(_ctx.currentLabel.label_name), 1),
              _hoisted_11,
              _createElementVNode("a", {
                target: "_blank",
                rel: "noopener noreferrer",
                href: _ctx.orderHistoryLink
              }, "Order History", 8, _hoisted_12),
              _hoisted_13
            ]),
            (_ctx.clientDimensions.width <= 900)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              id: "template-select",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openSizesModal && _ctx.openSizesModal(...args)))
            }, "Choose a Different Template ›"),
            _createElementVNode("div", {
              id: "help",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openContact()))
            }, "I need more help")
          ]),
          (_ctx.clientDimensions.width > 900)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ], 2)
  ]))
}